import React, { createContext, useContext, ReactNode } from 'react';
import type { GameTheme } from './GameContext';

export const FH6_GAME: GameTheme = {
  id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
  name: 'Forza Horizon 6',
  slug: 'forza-horizon-6',
  color: '#ffabf3',
};

interface Fh6ContextType {
  selectedGame: GameTheme;
}

const Fh6Context = createContext<Fh6ContextType | undefined>(undefined);

export const Fh6Provider: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Fh6Context.Provider value={{ selectedGame: FH6_GAME }}>
      <div data-game={FH6_GAME.slug}>
        {children}
      </div>
    </Fh6Context.Provider>
  );
};

export const useFh6 = () => {
  const context = useContext(Fh6Context);
  if (context === undefined) {
    throw new Error('useFh6 must be used within a Fh6Provider');
  }
  return context;
};
